import { render, staticRenderFns } from "./PaginaListadoRespuestasMuniIngresadas.vue?vue&type=template&id=07988af7"
import script from "./PaginaListadoRespuestasMuniIngresadas.vue?vue&type=script&lang=js"
export * from "./PaginaListadoRespuestasMuniIngresadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports